module.exports = __webpack_public_path__ + "fonts/Inter-BlackItalic.daa1ca3.woff2";